module.exports = __webpack_public_path__ + "img/tools.6a2845f7.svg";